
import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle 
} from "@/components/ui/dialog";
import { Doctor } from '@/types';
import DoctorForm from './DoctorForm';

interface DoctorFormDialogProps {
  isOpen: boolean;
  doctor: Partial<Doctor>;
  isEditing: boolean;
  onSave: () => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onCancel: () => void;
  imageFile: File | null;
  imagePreview: string;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onImageUrlChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const DoctorFormDialog: React.FC<DoctorFormDialogProps> = ({
  isOpen,
  doctor,
  isEditing,
  onSave,
  onInputChange,
  onCancel,
  imageFile,
  imagePreview,
  onFileChange,
  onImageUrlChange
}) => {
  const title = isEditing ? "Edit Doctor Information" : "Add New Doctor";
  
  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!open) onCancel();
    }}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DoctorForm
          doctor={doctor}
          isEditing={isEditing}
          onSave={onSave}
          onInputChange={onInputChange}
          onCancel={onCancel}
          imageFile={imageFile}
          imagePreview={imagePreview}
          onFileChange={onFileChange}
          onImageUrlChange={onImageUrlChange}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DoctorFormDialog;
